import { parseDate } from "@lyfegen-platform/utils";
import { format } from "date-fns";
import * as Yup from "yup";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { PIDataPoints } from "../models/flexible/primary-intervention-data-points";
import { TrFun } from "../utils/types";
import { GeneralFieldController } from "./general-field-controller";

export class RecurrenceDateFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translate: TrFun): Yup.AnySchema {
		const primaryIntervention = this.parent.context.cases
			.flatMap((cs) => cs.flexEntitiesConnection.edges)
			.find(({ isStartingPoint }) => isStartingPoint)?.node.data as unknown as PIDataPoints;
		if (!primaryIntervention) {
			return super.createValidationRule(initialData, translate);
		}

		const primaryInterventionDate = primaryIntervention.primaryInterventionDate;

		return (super.createValidationRule(initialData, translate) as Yup.DateSchema)
			.min(
				primaryInterventionDate,
				`${translate("must-be-after-pi-date")} - ${format(parseDate(primaryInterventionDate), "dd.MM.yyyy")}`
			)
			.max(new Date(), translate("cannot-be-greater-than-today"));
	}

	override useControlProps(): FlexControlProps {
		return {
			cannotBeFuture: true,
		};
	}
}
